import { useFragment } from '@apollo/client/react'

import { PostNoteTotal } from './fragments/PostNoteTotal'
import { PostUnreadMentionCount } from './fragments/PostUnreadMentionCount'
import { PostUnreadNoteCount } from './fragments/PostUnreadNoteCount'

/*
 * Each reader observes only its own field in the owning query's normalized
 * Post, so a query that selects one count never hides the other's reader.
 * Neither fetches.
 */

/** The viewer's unread Note count; `null` while unknown. */
export function usePostUnreadNoteCount(postId: string | null): number | null {
  const { data, complete } = useFragment({
    fragment: PostUnreadNoteCount,
    from: postId ? { __typename: 'Post', id: postId } : null,
  })
  return complete
    ? (data.collaborationNotesSummary?.unreadNoteCount ?? null)
    : null
}

/** The viewer's unread mention count; `null` while unknown. */
export function usePostUnreadMentionCount(
  postId: string | null,
): number | null {
  const { data, complete } = useFragment({
    fragment: PostUnreadMentionCount,
    from: postId ? { __typename: 'Post', id: postId } : null,
  })
  return complete
    ? (data.collaborationNotesSummary?.unreadMentionCount ?? null)
    : null
}

/** The Post's total Note count; `null` while unknown. */
export function usePostNoteTotal(postId: string | null): number | null {
  const { data, complete } = useFragment({
    fragment: PostNoteTotal,
    from: postId ? { __typename: 'Post', id: postId } : null,
  })
  return complete ? (data.collaborationNotesSummary?.noteCount ?? null) : null
}
